import React from 'react';
import Select, { OptionTypeBase } from 'react-select';
import styled from 'styled-components';
import GlobalSelectStyles from '@com/core/common/styles/GlobalSelectStyles';

type TCustomStyles = {
    [key: string]: Record<string, any>;
};

type TProps = {
    disabled?: boolean;
    selectedOption?: OptionTypeBase | null;
    options: OptionTypeBase[];
    placeholder?: string;
    customStyles?: TCustomStyles;
    onChange: (selectedOption: OptionTypeBase) => void;
};

const Dropdown = ({ customStyles, disabled, onChange, options, placeholder, selectedOption }: TProps): JSX.Element => {
    return (
        <SelectWrapper>
            <GlobalSelectStyles />
            <form>
                <Select
                    value={selectedOption || null}
                    options={options}
                    onChange={onChange}
                    isClearable={false}
                    isSearchable={false}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    styles={customStyles}
                />
            </form>
        </SelectWrapper>
    );
};

const SelectWrapper = styled.div`
    .sizingContainer :global(.Select.has-value.Select--single > .Select-control .Select-value .Select-value-label) {
        color: ${({ theme }): string => theme.colors.brandSecondary};
        font-weight: 600;
    }
    width: 100%;
`;

export default Dropdown;
